import { SeatRequestResponse } from "../contracts/SeatRequestResponse";
import { SeatStatus } from "../enums/SeatStatus";
import { SeatRequest } from "../models/SeatRequest";

/** Wire → model for staff-side Occurrence seats. */
export class SeatRequestResponseMapper {
  toSeatRequest(response: SeatRequestResponse): SeatRequest {
    return {
      seatId: response.seatId,
      bookingId: response.bookingId,
      sessionTitle: response.sessionTitle,
      occurrenceDate: response.occurrenceDate,
      timeLocal: response.timeLocal.slice(0, 5),
      timeZone: response.timeZone,
      memberId: response.memberId,
      memberName: response.memberName,
      status: response.status,
      source: response.source,
      requestedAt: response.requestedAt,
      isPending: response.status === SeatStatus.Requested,
    };
  }

  /** A missing list (null / undefined) maps to no seats. */
  toSeatRequests(responses: SeatRequestResponse[] | null | undefined): SeatRequest[] {
    return (responses ?? []).map((r) => this.toSeatRequest(r));
  }
}
